"use strict";

import React from 'react';

const Card = ({title='',text='', actionTitle='Edit', onClick=()=>{}, children}) => {
    return (
        <div className="echeck__card">
            <div className="echeck__card__header">
                {!!title && <h5 className="echeck__card__title">{title}</h5>}
                <div className="echeck__card__header__action">
                    <a href="#"
                       title={actionTitle}
                       className="btn__primary--outline btn--tiny"
                       onClick={onClick}>
                        edit
                    </a>
                </div>
            </div>
            {!!text && <p className="echeck__card__text">{text}</p>}
            {children}
        </div>
    );
};

export default Card;
